// Component-side reader of the per-practice attendance UI flag — see
// src/utils/attendanceUiFlag.js for the rule and why it fails closed.
import { useSelector } from '../redux/store';
import { attendanceUiEnabledFromState } from '../utils/attendanceUiFlag';

export default function useAttendanceUiEnabled(contextPracticeId) {
    return useSelector((state) => attendanceUiEnabledFromState(state, contextPracticeId));
}
